import { useState } from "react";

function initialForm(user, pin) {
  return {
    selected_nursery: "",
    full_name: user?.name || "",
    phone: user?.phone || "",
    whatsapp: "",
    email: user?.email || "",
    customer_type: "",
    company: "",
    address: "",
    pincode: pin || "",
    city: "",
    district: "",
    state: "",
    map_link: "",
    date: "",
    time: "",
    alt_date: "",
    property_type: "",
    area: "",
    area_unit: "Sq. Ft.",
    needs: [],
    budget: "",
    timeline: "",
    description: "",
    photos: [],
    documents: [],
    extra: {},
    consent: false,
    consultation_type: "first",
  };
}

export function useServiceRequestForm(user, pin) {
  const [form, setForm] = useState(() => initialForm(user, pin));
  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const updExtra = (k, v) => setForm((f) => ({ ...f, extra: { ...f.extra, [k]: v } }));
  const toggleNeed = (need) =>
    setForm((f) => ({
      ...f,
      needs: f.needs.includes(need) ? f.needs.filter((n) => n !== need) : [...f.needs, need],
    }));
  return { form, upd, updExtra, toggleNeed };
}
